import { useTranslation } from "react-i18next";

export const EditButtonRenderer = (props) => {
    const { t } = useTranslation()
      const handleClick = () => {
          const templateId = props.data.id; // Replace 'id' with the field you need
          const url = `/design/${templateId}/edit`;
          window.open(url, '_blank');
      };

      return <button onClick={handleClick} >{t('Edit')}</button>;
};